document.documentElement.classList.remove('no-js');

/* =========================================================
   Left sidebar submenu toggles
   ========================================================= */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.left-sidebar__navToggle').forEach((btn) => {
    btn.addEventListener('click', () => {
      const isExpanded = btn.getAttribute('aria-expanded') === 'true';
      const submenuId = btn.getAttribute('aria-controls');
      const submenu = document.getElementById(submenuId);
      if (!submenu) return;

      if (isExpanded) {
        // collapse
        btn.setAttribute('aria-expanded', 'false');
        submenu.classList.remove('is-open');
        // wait for transition then restore hidden
        const onEnd = (ev) => {
          if (ev.propertyName !== 'max-height') return;
          submenu.removeEventListener('transitionend', onEnd);
          submenu.setAttribute('hidden', '');
        };
        submenu.addEventListener('transitionend', onEnd);
      } else {
        // expand
        btn.setAttribute('aria-expanded', 'true');
        submenu.removeAttribute('hidden');
        // force reflow so transition triggers
        void submenu.offsetHeight;
        submenu.classList.add('is-open');
      }
    });
  });
});
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.pacc').forEach((details) => {
    const summary = details.querySelector('.pacc__summary');
    const content = details.querySelector('.pacc__content');
    if (!summary || !content) return;

    summary.addEventListener('click', (e) => {
      e.preventDefault(); // ✅ stop native toggle

      const isOpen = details.hasAttribute('open');

      // helper: force reflow so transitions always trigger
      const forceReflow = () => void content.offsetHeight;

      // OPEN
      if (!isOpen) {
        details.setAttribute('open', '');

        details.classList.add('is-animating');
        content.style.overflow = 'hidden';
        content.style.maxHeight = '0px';
        content.style.opacity = '0';

        forceReflow();

        const target = content.scrollHeight;
        content.style.maxHeight = target + 'px';
        content.style.opacity = '1';

        const onEnd = (ev) => {
          if (ev.propertyName !== 'max-height') return;
          content.removeEventListener('transitionend', onEnd);

          details.classList.remove('is-animating');
          content.style.maxHeight = 'none'; // allow dynamic content growth
          content.style.overflow = '';
          content.style.opacity = '1';
        };

        content.addEventListener('transitionend', onEnd);
        return;
      }

      // CLOSE
      // First set maxHeight to current px (if it was 'none', convert to px)
      details.classList.add('is-animating');
      content.style.overflow = 'hidden';
      content.style.maxHeight = content.scrollHeight + 'px';
      content.style.opacity = '1';

      forceReflow();

      content.style.maxHeight = '0px';
      content.style.opacity = '0';

      const onEnd = (ev) => {
        if (ev.propertyName !== 'max-height') return;
        content.removeEventListener('transitionend', onEnd);

        details.classList.remove('is-animating');
        details.removeAttribute('open'); // ✅ close after animation finishes
        content.style.overflow = '';
        content.style.maxHeight = '0px';
      };

      content.addEventListener('transitionend', onEnd);
    });
  });
});
